import React, { useState } from 'react';
import styled from 'styled-components';

import { CARD_TYPES, CARD_WRAPPER_TYPES } from '../../../shared/constants';
import { ICard } from '../../../types/shared';

import ReactMarkdownExtended from '../../../utils/generic/ReactMarkdownExtended';
import { parseSectionID } from '../../../utils/string-utils';

import mq from '../../../styles/breakpoints';
import { IntroText, ProductPageH2 } from '../../../styles/generic';

import FaqItem from '../faq-item/FaqItem';

interface Props {
  title: string;
  subtitle: string;
  cards: ICard[];
  anchorName?: string;
}

const FaqWrapper = ({ title, subtitle, cards, anchorName }: Props) => {
  const [activeItem, setActiveItem] = useState('');
  const handleOnChange = (event: { open: boolean; id: string }) => {
    setActiveItem(event.open ? event.id : '');
  };
  const id = parseSectionID(CARD_WRAPPER_TYPES.faqWrapper, anchorName);

  return (
    <Container id={id}>
      {(title || subtitle) && (
        <TextContainer>
          {title && <Title data-testid="title">{title}</Title>}
          {subtitle && (
            <StyledIntroText data-testid="subtitle">{subtitle}</StyledIntroText>
          )}
        </TextContainer>
      )}
      <Body>
        {cards?.map((card, key) => (
          <FaqItem
            key={key}
            id={card.id}
            title={card.title}
            onChange={handleOnChange}
            open={activeItem === card.id}
          >
            <ReactMarkdownExtended componentType={CARD_TYPES.faqItem}>
              {card.body.childMarkdownRemark.rawMarkdownBody}
            </ReactMarkdownExtended>
          </FaqItem>
        ))}
      </Body>
    </Container>
  );
};

export default FaqWrapper;

const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0;
  height: auto;
  justify-content: center;
  max-width: 840px;
  width: 100%;
`;

const TextContainer = styled.div`
  margin-bottom: 40px;

  ${mq.from.breakpoint.M`
    margin-bottom: 60px;
  `}
`;

const Title = styled(ProductPageH2)`
  margin: 0;
  text-align: center;
  width: inherit;
`;

const StyledIntroText = styled(IntroText)`
  display: block;
  margin-top: 8px;

  ${mq.from.breakpoint.M`
    margin-top: 16px;
  `}
`;

const Body = styled.div`
  width: inherit;

  p {
    margin: 16px 0;
  }
`;
